import { FETCH_WHATSNEW, GET_WHATSNEW, CREATE_WHATSNEW, UPDATE_WHATSNEW, DELETE_WHATSNEW } from 'actions/whatsNew';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* fetchWhatsNew(action) {
  try {
    const response = yield call(API.getWhatsNew, action.payload);
    yield put({ type: FETCH_WHATSNEW.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_WHATSNEW.FAIL, payload: { error: e } });
  }
}

function* getWhatsNewById(action) {
  try {
    const response = yield call(API.getWhatsNewById, action.payload);
    yield put({ type: GET_WHATSNEW.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_WHATSNEW.FAIL, payload: { error: e } });
  }
}

function* createWhatsNew(action) {
  try {
    const response = yield call(API.addWhatsNew, action.payload);
    yield put({ type: CREATE_WHATSNEW.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_WHATSNEW.FAIL, payload: { error: e } });
  }
}

function* updateWhatsNew(action) {
  try {
    const response = yield call(API.updateWhatsNew, action.payload);
    yield put({ type: UPDATE_WHATSNEW.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_WHATSNEW.FAIL, payload: { error: e } });
  }
}

function* deleteWhatsNew(action) {
  try {
    const response = yield call(API.deleteWhatsNew, action.payload);
    yield put({ type: DELETE_WHATSNEW.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_WHATSNEW.FAIL, payload: { error: e } });
  }
}

function* whatsNewSaga() {
  yield takeLatest(FETCH_WHATSNEW.REQUEST, fetchWhatsNew);
  yield takeLatest(GET_WHATSNEW.REQUEST, getWhatsNewById);
  yield takeLatest(CREATE_WHATSNEW.REQUEST, createWhatsNew);
  yield takeLatest(UPDATE_WHATSNEW.REQUEST, updateWhatsNew);
  yield takeLatest(DELETE_WHATSNEW.REQUEST, deleteWhatsNew);
}

export default whatsNewSaga;
